import React from 'react'

// 空函数
export const noon = () => {}

// 获取文件后缀名
export const getFileExt = (fileName: string | undefined) => {
  if (typeof fileName === 'string') {
    return fileName.split('.')?.[fileName.split('.')?.length - 1]
  }
  return 'undefined'
}

// 判断文件是否为图片
export const veryImage = (fileName: string | undefined) => {
  if (typeof fileName === 'string') {
    const ext = getFileExt(fileName)
    return (
      [
        'png',
        'jpg',
        'jpeg',
        'bmp',
        'gif',
        'webp',
        'psd',
        'svg',
        'tiff',
      ].indexOf((ext as string).toLowerCase()) !== -1
    )
  }
  return false
}

// 判断文件是否为视频
export const veryVideo = (fileName: string | undefined) => {
  if (typeof fileName === 'string') {
    const ext = getFileExt(fileName)
    return ['mp4', 'webm', 'ogg'].indexOf((ext as string).toLowerCase()) !== -1
  }
  return false
}

// 判断文件是否为音频
export const veryAudio = (fileName: string | undefined) => {
  if (typeof fileName === 'string') {
    const ext = getFileExt(fileName)
    return ['mp3', 'wav', 'ogg'].indexOf((ext as string).toLowerCase()) !== -1
  }
  return false
}

// 判断文件是否为excel
export const veryExcel = (fileName: string | undefined) => {
  if (typeof fileName === 'string') {
    const ext = getFileExt(fileName)
    return ['xls', 'xlsx'].indexOf((ext as string).toLowerCase()) !== -1
  }
  return false
}

// 判断文件是否为word
export const veryWord = (fileName: string | undefined) => {
  if (typeof fileName === 'string') {
    const ext = getFileExt(fileName)
    return ['doc', 'docx'].indexOf((ext as string).toLowerCase()) !== -1
  }
  return false
}

// 判断文件是否为pdf
export const veryPdf = (fileName: string | undefined) => {
  if (typeof fileName === 'string') {
    const ext = getFileExt(fileName)
    return ['pdf'].indexOf((ext as string).toLowerCase()) !== -1
  }
  return false
}

export const judeFileTypeName = (type: string | undefined) => {
  const fileType: string = type?.split('/')?.[0] || ''
  let fileTypeName = '文件'
  switch (fileType) {
    case 'image':
      fileTypeName = '图片'
      break
    case 'audio':
      fileTypeName = '音频'
      break
    case 'video':
      fileTypeName = '视频'
      break
    default:
      break
  }
  return fileTypeName
}

export const judeSiteGif = (fileName?: string | undefined, url?: string) => {
  if (typeof fileName === 'string') {
    if (veryImage(fileName)) {
      return url
    }
    if (veryVideo(fileName)) {
      return (
        <svg
          className="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          width="200"
          height="200"
        >
          <path
            d="M896 243.882V256H640V0h12.118c12.73 0 24.94 5.058 33.942 14.058l195.882 195.882A48.01 48.01 0 0 1 896 243.882zM576 272V0H176C149.49 0 128 21.49 128 48v928c0 26.51 21.49 48 48 48h672c26.51 0 48-21.49 48-48V320H624c-26.4 0-48-21.6-48-48z m192 288.032v223.926c0 42.89-51.886 63.996-81.942 33.942L576 707.882V784c0 26.51-21.49 48-48 48H304c-26.51 0-48-21.49-48-48V560c0-26.51 21.49-48 48-48h224c26.51 0 48 21.49 48 48v76.118l110.058-110.026c30.022-30.02 81.942-8.982 81.942 33.94z"
            fill=""
          />
        </svg>
      )
    }
    if (veryAudio(fileName)) {
      return (
        <svg
          className="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          width="200"
          height="200"
        >
          <path d="M682.666667 85.333333l213.333333 213.333334v597.674666a42.368 42.368 0 0 1-42.368 42.325334H170.368A42.666667 42.666667 0 0 1 128 896.341333V127.658667C128 104.277333 146.986667 85.333333 170.368 85.333333H682.666667z m-213.333334 428.8a106.666667 106.666667 0 1 0 85.333334 104.533334V426.666667h128V341.333333h-213.333334v172.8z" />
        </svg>
      )
    }
    if (veryExcel(fileName)) {
      return (
        <svg
          className="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          width="200"
          height="200"
        >
          <path d="M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM575.341 477.839l-61.216 102.307-61.839-102.351a12 12 0 0 0-10.27-5.795h-38.437a12 12 0 0 0-6.406 1.853c-5.604 3.538-7.279 10.949-3.741 16.553l82.333 130.422-83.449 132.787a12 12 0 0 0-1.84 6.385c0 6.627 5.373 12 12 12h34.466a12 12 0 0 0 10.208-5.692l62.707-101.474 62.29 101.445A12 12 0 0 0 582.375 772h37.486a12 12 0 0 0 6.484-1.903c5.577-3.58 7.195-11.004 3.614-16.58l-83.831-130.551 85.296-132.47a12 12 0 0 0 1.91-6.496c0-6.627-5.372-12-12-12h-35.695a12 12 0 0 0-10.297 5.839z" />
        </svg>
      )
    }
    if (veryWord(fileName)) {
      return (
        <svg
          className="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          width="200"
          height="200"
        >
          <path d="M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 566.095l52.814 197.012a12 12 0 0 0 11.59 8.893h31.78a12 12 0 0 0 11.587-8.878l74.375-276a12 12 0 0 0 0.413-3.122c0-6.627-5.373-12-12-12h-35.576a12 12 0 0 0-11.695 9.31l-45.79 199.105-49.76-199.321A12 12 0 0 0 528.097 472h-32.192a12 12 0 0 0-11.643 9.094l-49.66 198.927-46.096-198.732a12 12 0 0 0-11.69-9.289h-35.381a12 12 0 0 0-3.115 0.411c-6.4 1.72-10.194 8.303-8.474 14.703l74.173 276A12 12 0 0 0 415.606 772h31.99a12 12 0 0 0 11.59-8.893L512 566.095z" />
        </svg>
      )
    }
    if (veryPdf(fileName)) {
      return (
        <svg
          className="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          width="200"
          height="200"
        >
          <path d="M491.8 512.2c-10-32-9.8-93.8-4-93.8 16.8 0 15.2 73.8 4 93.8z m-3.4 94.4c-15.4 40.4-34.6 86.6-56.8 125.4 36.6-14 78-34.4 125.8-43.8-25.4-19.2-49.8-46.8-69-81.6zM300.2 856.2c0 1.6 26.4-10.8 69.8-80.4-13.4 12.6-58.2 49-69.8 80.4zM624 320h272v656c0 26.6-21.4 48-48 48H176c-26.6 0-48-21.4-48-48V48C128 21.4 149.4 0 176 0h400v272c0 26.4 21.6 48 48 48z m-16 343.6c-40-24.4-66.6-58-85.4-107.6 9-37 23.2-93.2 12.4-128.4-9.4-58.8-84.8-53-95.6-13.6-10 36.6-0.8 88.2 16.2 154-23.2 55.2-57.4 129.2-81.6 171.6-0.2 0-0.2 0.2-0.4 0.2-54.2 27.8-147.2 89-109 136 11.2 13.8 32 20 43 20 35.8 0 71.4-36 122.2-123.6 51.6-17 108.2-38.2 158-46.4 43.4 23.6 94.2 39 128 39 58.4 0 62.4-64 39.4-86.8-27.8-27.2-108.6-19.4-147.2-14.4zM882 210L686 14c-9-9-21.2-14-34-14h-12v256h256v-12.2c0-12.6-5-24.8-14-33.8z m-148.2 510.6c8.2-5.4-5-23.8-85.6-18 74.2 31.6 85.6 18 85.6 18z" />
        </svg>
      )
    }
  }
  return (
    <svg
      className="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="200"
      height="200"
    >
      <path
        d="M896 243.882V256H640V0h12.118c12.73 0 24.94 5.058 33.942 14.058l195.882 195.882A48.01 48.01 0 0 1 896 243.882zM576 272V0H176C149.49 0 128 21.49 128 48v928c0 26.51 21.49 48 48 48h672c26.51 0 48-21.49 48-48V320H624c-26.4 0-48-21.6-48-48z m192 288.032v223.926c0 42.89-51.886 63.996-81.942 33.942L576 707.882V784c0 26.51-21.49 48-48 48H304c-26.51 0-48-21.49-48-48V560c0-26.51 21.49-48 48-48h224c26.51 0 48 21.49 48 48v76.118l110.058-110.026c30.022-30.02 81.942-8.982 81.942 33.94z"
        fill=""
      />
    </svg>
  )
}
